import { UsersAnalysisMetricsEnum } from "@/includes/types/statistics/usersAnalysis";

export const TOXICITY_METRICS = [
  UsersAnalysisMetricsEnum.Toxicity,
  UsersAnalysisMetricsEnum.SevereToxicity,
  UsersAnalysisMetricsEnum.Profanity ] as const
